// Ravi 11/17/2022 2700271704  Render options of dropDown value
// Sai krishna 11/17/2022 2700271704 Action dropdown -- Validation bug fixes.
// Sai Maheshwar 11/20/2022 2700271704 fixed add action bugs and added validations
// Sohel 11/21/2022 2700271704 field update group dropdown value changes
// Raghu 02/28/2023 2700271704 added new classname for input feilds
// Prakash 10/05/2023 2700271704 add theming color
import {
  FormControl,
  FormHelperText,
  Grid,
  InputLabel,
  MenuItem,
  Select,
} from '@material-ui/core';
import React, {useContext, useEffect} from 'react';
import {fetchAllGroupCode} from '../../../../../redux/reducers/AccountUpdateGroup';
import {useDispatch, useSelector} from 'react-redux';
import {ThemeContext} from '../../../../../themes/ThemeProvider';
import GuiAutoComplete from '../../../../../components/FormComponents/GuiAutoComplete';
import GuiTextField from '../../../../../components/FormComponents/GuiTextField';
const UpdateFieldsOnAccount = (props) => {
  const {reusableInputStyles} = useContext(ThemeContext);
  const classes = reusableInputStyles();
  const {values, handleChange, errors, handleBlur, touched, setFieldValue} = props;
  const {allGroupCode} = useSelector(({accountUpdateGroup}) => accountUpdateGroup);
  const dispatch = useDispatch();
  const overRideOption = [
    {key: 'A', value: 'A - Account'},
    {key: 'S', value: 'S - Seed'},
    {key: 'R', value: 'R - Route'},
  ];

  useEffect(() => {
    dispatch(fetchAllGroupCode());
  }, []);
  return (
    <Grid container spacing={4} className="new-standard-textfields m-0">
      <Grid
        item
        xs={4}
        sm={4}
        className={`form-group ${classes.selectField}`}
      >
        <FormControl margin="dense" variant="outlined" fullWidth>
          <InputLabel id="demo-simple-select-label" required>
            Apply To
          </InputLabel>
          <Select
            id="demo-simple-select"
            labelId="demo-simple-select-label"
            fullWidth
            name="applyTo"
            className={` select-gender ${classes.labelName}`}
            required
            value={values?.applyTo || 'none'}
            onChange={handleChange}
            onBlur={handleBlur}
            touched={touched?.applyTo}
            // error={Boolean(touched?.applyTo && errors?.applyTo)}
            label={'Select Apply To'}
          >
            <MenuItem value="none" key="none" disabled>
              <span className="defaultSelected"> Select Apply To </span>
            </MenuItem>
            {overRideOption.map((option) => {
              return (
                <MenuItem value={option.key} key={option.key}>
                  {option.value}
                </MenuItem>
              );
            })}
          </Select>
        </FormControl>
        <FormHelperText>{touched?.applyTo && errors && errors.applyTo}</FormHelperText>
      </Grid>
      <Grid item xs={4} sm={4} className={`form-group `}>
        <GuiAutoComplete
          classes={{
            option: classes.option,
          }}
          name="fieldUpdateGroup"
          id="fieldUpdateGroup"
          size="small"
          options={allGroupCode}
          onBlur={handleBlur}
          required
          value={values?.fieldUpdateGroup || 'none'}
          getOptionDisabled={(option) => option.groupCode === 'none'}
          getOptionLabel={(option) => {
            return option && option?.groupDescription ?
              option?.groupCode === null ?
                option?.groupDescription :
                option?.groupCode + ' - ' + option?.groupDescription :
              '';
          }}
          onChange={(e, value) => {
            setFieldValue('fieldUpdateGroup', value);
          }}
          renderInput={(params) => (
            <div className="select-field">
              <GuiTextField
                {...params}
                // className={` ${classes.labelName} ${classes.selectLabel}`}
                variant="outlined"
                margin="dense"
                className={` ${classes.labelName}`}
                required
                InputLabelProps={{shrink: true}}
                label="Field Update Group"
                placeholder="Select Field Update Group"
                touched={touched?.fieldUpdateGroup}
                error={Boolean(touched?.fieldUpdateGroup && errors?.fieldUpdateGroup)}
              />
            </div>
          )}
        />
        <FormHelperText>
          {touched?.fieldUpdateGroup && errors && errors.fieldUpdateGroup}
        </FormHelperText>
      </Grid>
    </Grid>
  );
};
export default UpdateFieldsOnAccount;
